import {
  faLock,
  faLockOpen,
  faSnowflake,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { useBoolean, useDebounce } from "usehooks-ts";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import _ from "lodash";
import { prependToMemberExpression } from "@babel/types";

type Range = [number, number];

export const useMinMax = (props: { initialValue: [string, string] }) => {
  const { initialValue = ["0", "0"] } = props;
  const [_min, _setMin] = React.useState(initialValue[0]);
  const [_max, _setMax] = React.useState(initialValue[1]);
  const min = useDebounce(_min);
  const max = useDebounce(_max);
  const isLocked = useBoolean(true); //sets and keeps max = min

  const minNum = Number.parseFloat(min);
  const maxNum = Number.parseFloat(max);

  return {
    range: [minNum, isLocked.value ? minNum : maxNum] as Range,
    rangeRaw: [_min, isLocked.value ? _min : _max],
    setMin: _setMin,
    setMax: _setMax,
    isLocked,
  };
};

type MinMaxProps = ReturnType<typeof useMinMax>;

interface Props {
  state: MinMaxProps;
  label: string;
}

export const MinMax = (props: Props) => {
  const { range, rangeRaw, setMin, setMax, isLocked } = props.state;

  return (
    <div className="input-group mb-3">
      <span className="input-group-text">{props.label}</span>
      <input
        onFocus={(e) => e.target.select()}
        className="form-control"
        type="text"
        value={rangeRaw[0]}
        onChange={(e) => {
          setMin(e.target.value);
        }}
      />
      {!isLocked.value && (
        <>
          <span className="input-group-text">-</span>
          <input
            onFocus={(e) => e.target.select()}
            className="form-control"
            type="text"
            value={rangeRaw[1]}
            onChange={(e) => {
              setMax(e.target.value);
            }}
          />
        </>
      )}
      <span
        style={{ cursor: "pointer" }}
        className="input-group-text"
        onClick={isLocked.toggle}
      >
        {isLocked.value ? (
          <FontAwesomeIcon
            title="Winter"
            icon={faLock}
            size={"1x"}
            fixedWidth
          />
        ) : (
          <FontAwesomeIcon
            title="Winter"
            icon={faLockOpen}
            size={"1x"}
            fixedWidth
          />
        )}
      </span>
      <span
        style={{ cursor: "pointer" }}
        className="input-group-text"
        onClick={() => {
          setMin("0");
          setMax("0");
        }}
      >
        0
      </span>
      <span
        style={{ cursor: "pointer" }}
        className="input-group-text"
        onClick={() => {
          setMin("");
          setMax("");
        }}
      >
        {/* <FontAwesomeIcon title="Winter" icon={faTrash} size={"1x"} fixedWidth /> */}
        ?
      </span>
    </div>
  );
};
